export default __webpack_public_path__ + "static/client4-1037c43ff7efb392d172a4910619c731.png";